export default __webpack_public_path__ + "static/media/J270_CoC.e3d1893d.pdf";